import { render } from "./ValetTariffeSection.vue?vue&type=template&id=3808fda3&scoped=true"
import script from "./ValetTariffeSection.vue?vue&type=script&lang=js"
export * from "./ValetTariffeSection.vue?vue&type=script&lang=js"

import "./ValetTariffeSection.vue?vue&type=style&index=0&id=3808fda3&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3808fda3"]])

export default __exports__